export enum DatasheetFormatType {
  individual = "individual",
  pedigree = "pedigree",
  table = "table",
}
